<template>
  <div>
    <v-calendar></v-calendar>
  </div>
</template>

<script>
import VCalendar from 'v-calendar/lib/components/calendar.umd';

export default {
  name: 'IpsCalendar',
  components: { VCalendar },
  mixins: [],
  props: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>
